/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'walking-fingers-round-black': {
    width: 35,
    height: 35,
    viewBox: '0 0 35 35',
    data:
      '<path pid="0" d="M16.777 22.559s1.136-2.659 1.136-3.458c0-.801-1.265-1.395-1.445-1.395h-.93c-.18.388-.748 3.589-.748 3.589s-2.168 2.786-2.168 3.406c0 .852.722 1.549 1.549 1.549l2.606-3.691zm-5.085-11.486s1.549 2.478 1.549 3.407c0 .93-1.858 2.788-2.478 3.407-.62.62-.31 1.859.62 1.859.929 0 2.478-1.549 2.478-1.549s1.548-1.549 2.477-1.549c.93 0 1.858.93 1.858.93s2.169 3.097 2.789 4.026c.619.93.929 2.477 1.239 3.407.31.93 1.548 1.239 1.548 1.239h.93s-1.24-4.646-1.55-5.885c-.31-1.239-3.097-6.194-4.026-8.673-.93-2.478-2.942-2.942-3.562-2.942h-5.266l1.394 2.323zM35 17.5C35 27.165 27.165 35 17.5 35S0 27.165 0 17.5 7.835 0 17.5 0 35 7.835 35 17.5z" _fill="#000" fill-rule="evenodd"/>'
  }
})
